import React, { useState } from 'react'
import useStyles from './style'
import { Grid, Typography, Zoom } from '@mui/material'
import { numberToIndianRupee } from 'utils/numberToIndianRupee'
import { API_ENDPOINTS } from 'constants'
import _ from 'lodash'
import VisibilitySensor from 'react-visibility-sensor'
import { useNavigate } from 'react-router-dom'

const list = [
  {
    id: 1,
    img: '/assets/images/products/bangles.webp',
    name: 'Golded Bangles',
    price: 12000,
  },
  {
    id: 2,
    img: '/assets/images/products/bracelets.webp',
    name: 'Sleek Bracelet',
    price: 15000,
  },
  {
    id: 3,
    img: '/assets/images/products/coin.webp',
    name: 'Rounded Gold Coin',
    price: 7000,
  },
  {
    id: 4,
    img: '/assets/images/products/earrings.webp',
    name: 'Pearl Earrings',
    price: 25000,
  },
  {
    id: 5,
    img: '/assets/images/products/mangalsutras.webp',
    name: 'Pearl Mangalsutras',
    price: 55000,
  },
  {
    id: 6,
    img: '/assets/images/products/necklace.webp',
    name: 'Golden Necklace',
    price: 80000,
  },
  {
    id: 7,
    img: '/assets/images/products/nosepins.webp',
    name: 'Pearl Golden Nosepin',
    price: 29875,
  },
  {
    id: 8,
    img: '/assets/images/products/pendant.webp',
    name: 'Diamond Pendant',
    price: 109345,
  },
  {
    id: 9,
    img: '/assets/images/products/weddingring.webp',
    name: 'Platinum Wedding Ring',
    price: 31570,
  },
]

const LatestProducts = (props) => {
  const { latestProducts } = props
  const classes = useStyles()
  const navigate = useNavigate()
  const [isVisible, setIsVisible] = useState(false)

  const onVisibilityChange = (isVisible) => {
    setIsVisible(isVisible)
  }

  return (
    <>
      {!_.isEmpty(latestProducts) ? (
        <VisibilitySensor
          onChange={onVisibilityChange}
          partialVisibility={true}
        >
          <Grid container className={classes.root}>
            <Grid item xs={12} className={classes.title}>
              <Typography variant="h2">Latest Products</Typography>
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              {latestProducts?.map((data) => (
                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  lg={3}
                  key={data?.id}
                  className={classes.cardWrapper}
                >
                  <Zoom in={isVisible} timeout={1700}>
                    <Grid
                      item
                      xs={12}
                      className={classes.card}
                      onClick={() => navigate(`/product/${data?.productid}`)}
                    >
                      <img
                        src={
                          API_ENDPOINTS?.FILE_URL + data?.image?.[0]?.filename
                        }
                        alt={data?.label}
                        className={classes.img}
                      />
                      <div className={classes.content}>
                        <div className={classes.name}>
                          <Typography variant="body2">{data?.product_stylename === data?.name || !data?.product_stylename ? null : data?.product_stylename }</Typography>
                          <div>
                            <Typography variant="body1">
                              {data?.name || data?.product_stylename}
                              {/* &#x20b9; {numberToIndianRupee(data?.price)} */}
                            </Typography>
                          </div>
                        </div>
                        {/* <div className={classes.price}>
                          <Typography variant="body2">
                            <span style={{ fontSize: 16, fontWeight: 400 }}>
                              &#x20b9;
                            </span>{' '}
                            {numberToIndianRupee(data?.price)}
                          </Typography>
                        </div> */}
                      </div>
                    </Grid>
                  </Zoom>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </VisibilitySensor>
      ) : (
        <></>
      )}
    </>
  )
}

export default LatestProducts
